<div class="flex flex-col !gap-5">
  <div class="header flex flex-row items-center justify-between">
    <div class="flex flex-row items-center">
      <ion-icon src="../../../assets/icon/red-alert.svg"></ion-icon>
      <h1>¡ATENCIÓN!</h1>
    </div>

    <ion-button fill="clear" class="close" (click)="close()">
      <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
    </ion-button>
  </div>

  <hr />

  <h2>Vas a eliminar los siguientes datos de {{ type === 'shipping' ? 'envío:' : 'facturación:' }}</h2>

  <div class="address-info flex flex-col gap-2.5">
    <span>
      {{ address.organization || address.recipient }}
    </span>

    <span *ngIf="type === 'billing'">
      {{ address.taxId }}
    </span>

    <span *ngIf="type === 'shipping'">
      {{ address.phone }}
    </span>
    <span *ngIf="type === 'shipping' && address.email">
      {{ address.email }}
    </span>

    <span>
      {{ address.addressLine1 }}
    </span>
    <span>
      {{ address.postalCode }}
    </span>
    <span> {{ address.city }}, {{ address.province }} </span>
  </div>

  <hr />

  <div class="buttons flex flex-row items-center justify-end gap-2.5">
    <button class="gray" (click)="close()">Cancelar</button>
    <button (click)="accept()" class="flex flex-row items-center gap-2.5">
      <ion-icon src="../../../assets/icon/eliminar.svg"></ion-icon>
      <span>Eliminar</span>
    </button>
  </div>
</div>
